import { render, staticRenderFns } from "./CustomerServicePhone.vue?vue&type=template&id=5299f72e"
import script from "./CustomerServicePhone.vue?vue&type=script&lang=js"
export * from "./CustomerServicePhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports